module.exports = __webpack_public_path__ + "img/terminal-2.a083a92c.webp";